// @flow
import * as React from "react";
import AsyncSelect from "react-select/lib/Async";
import { reactSelectStyles, reactSelectTheme } from "../../constants/reactSelect";

type Props = {
  onChange: (any) => void,
  disabled?: boolean,
  Clients: (string) => Promise<{
    clients: Array<{ node: { clientId: number, name: string } }>,
  }>,
  value?: Array<{ value: number, label: string }> | null,
};

type clientNode = { node: { clientId: number, name: string } };

// Multi-select variant of ClientSelect: lets an admin pick additional (non-default) clients
// for a user. onChange receives an array of { clientId, name }.
class MultiClientSelect extends React.Component<Props> {
  getOptions = (input: any, callback: (any) => void) => {
    this.props
      .Clients(input)
      .then((response) => {
        const cachedClientsList = response.clients.map((client: clientNode) => ({
          value: client.node.clientId,
          label: client.node.name,
        }));
        callback(cachedClientsList);
      })
      .catch(function (error) {
        callback(error);
      });
  };
  handleChange = (values: Array<{ value: number, label: string }>, actionMeta: Object) => {
    this.props.onChange(
      (values || []).map((v) => ({
        clientId: v.value,
        name: v.label,
      }))
    );
  };
  render() {
    return (
      <AsyncSelect
        isMulti
        name="additional-clients"
        placeholder="Select additional clients (optional)"
        openMenuOnFocus
        defaultOptions
        cacheOptions={false}
        loadOptions={this.getOptions}
        value={this.props.value}
        backspaceRemoves={true}
        onChange={this.handleChange}
        isDisabled={this.props.disabled}
        styles={reactSelectStyles}
        theme={reactSelectTheme}
      />
    );
  }
}

export default MultiClientSelect;
